export const props = {
    props:
    {
        label:
        {
            type: String,
            default: '',
        },

        onClick:
        {
            type: Function,
        },
    },
};

export const computed = {
    computed: {},
};

export const methods = {
    methods: {},
}